import { render, staticRenderFns } from "./Infographic3.vue?vue&type=template&id=5c37bed8&scoped=true&"
import script from "./Infographic3.vue?vue&type=script&lang=js&"
export * from "./Infographic3.vue?vue&type=script&lang=js&"
import style0 from "./Infographic3.vue?vue&type=style&index=0&id=5c37bed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c37bed8",
  null
  
)

export default component.exports